export default {
  // Auth pages
  'signIn.title': '로그인',
  'signIn.subtitle': 'PackVerse에 다시 오신 것을 환영합니다',
  'signIn.email': '이메일 주소',
  'signIn.password': '비밀번호',
  'signIn.forgotPassword': '비밀번호를 잊으셨나요?',
  'signIn.button': '로그인',
  'signIn.noAccount': '계정이 없으신가요?',
  'signIn.signUpLink': '회원가입',
  'signIn.or': '또는 다음으로 계속',
  'signIn.google': 'Google',
  'signIn.facebook': 'Facebook',
  'signIn.error.invalid': '이메일 또는 비밀번호가 올바르지 않습니다',
  'signIn.error.noSupabase': '서버 연결이 설정되지 않았습니다. 관리자에게 문의해 주세요.',
  'signIn.error.generic': '오류가 발생했습니다. 다시 시도해 주세요.',

  'signUp.title': '회원가입',
  'signUp.subtitle': 'PackVerse에 무료로 가입하세요',
  'signUp.fullName': '성명',
  'signUp.email': '이메일 주소',
  'signUp.password': '비밀번호',
  'signUp.passwordHint': '6자 이상 입력',
  'signUp.confirmPassword': '비밀번호 확인',
  'signUp.button': '계정 만들기',
  'signUp.hasAccount': '이미 계정이 있으신가요?',
  'signUp.signInLink': '로그인',
  'signUp.or': '또는 다음으로 가입',
  'signUp.google': 'Google',
  'signUp.facebook': 'Facebook',
  'signUp.error.passwordMatch': '비밀번호가 일치하지 않습니다',
  'signUp.error.weakPassword': '비밀번호는 6자 이상이어야 합니다',
  'signUp.error.noSupabase': '서버 연결이 설정되지 않았습니다. 관리자에게 문의해 주세요.',
  'signUp.error.generic': '회원가입 중 오류가 발생했습니다. 다시 시도해 주세요.',
  'signUp.success': '계정이 성공적으로 생성되었습니다! 이메일을 확인하여 인증해 주세요.',
  'signUp.terms': '가입하면 서비스 약관 및 개인정보 처리방침에 동의하게 됩니다.',

  'logout': '로그아웃',
  'myAccount': '내 계정',
  'dashboard': '대시보드',

  'customerAccount': '고객 계정',
  'adminBadge': '관리자',
  'myQuotes': '내 견적 내역',
  'myOrders': '내 주문 내역',
  'aiPreviews': 'AI 마감 프리뷰',
  'savedProducts': '관심 상품',
  'companyProfile': '회사 정보',
  'shippingAddress': '배송 주소',
  'accountSettings': '계정 설정',
  'adminConsole': '관리자 콘솔',
};